import React from 'react';

import { Checkbox } from 'antd';

import { getIn } from 'formik';
import type { FieldProps } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';

interface IProps extends FieldProps {
  label: string;
  fullWidth?: boolean;
  checked?: boolean;
}

export const CheckboxFormField = ({ field, form, label, checked, fullWidth = true, ...props }: IProps) => {
  const errorText = getIn(form.errors, field.name);

  function handleChange(e: any) {
    form.setFieldValue(field.name, e.target.checked);
  }

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      <Hint inputName={field.name}>
        <Checkbox checked={checked || !!field.value || false} onChange={handleChange} {...props}>
          {label}
        </Checkbox>
      </Hint>
      {errorText && <p className='mt-1 text-xs text-red-500'>{errorText}</p>}
    </div>
  );
};
